import React, { Component } from "react";
import PropTypes from "prop-types"
import { Link, withRouter } from "react-router-dom";
import { Card, CardBody, Col, Container, Media, Row, Offcanvas, OffcanvasHeader, OffcanvasBody, FormGroup, Label, Table } from "reactstrap";
import axios from 'axios';
import { API_URL } from "helpers/app_url";
import avatar2 from "../../assets/img/email-profile.jpg";

import Breadcrumbs from "../../components/Common/Breadcrumb";

import EmailSideBar from "./email-sidebar";
import { Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";

import EmailToolbar from "./email-toolbar";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import UpdateButton from "components/buttons/updateBtn";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select"
import ClientEngagementListBuyer from "components/dropdowns/Lead/EngagementListBuyer";
import ClientEngagementListSellerEmail from "components/dropdowns/Lead/EngagementListSellerEmail";
import moment from "moment";
import SafeHTML from "components/buttons/SafeHTML";

class EmailSeller extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailData: null,
      loading: true,
      error: null,
      agentData: '',
      clients: [],
      extractData: [],
      listings:[],
      selectedMulti2: null,
      optionGroup1:[],
      typeId:"2"
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleMulti2 = this.handleMulti2.bind(this)
    
  }
  handleMulti2 = selectedMulti2 => {
    this.setState({ selectedMulti2 })
  }
  getUserType = (type) => {
    if(type==3)
      return 'Lead';
    else if(type==2)
    return 'Client';
    
  }
  handleTypeChange = (event) => {
    this.setState({ typeId: event.target.value });
  };
  componentDidMount() {

    this.fetchEmailData();
    this.fetchOptions(this.state.typeId);

    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const userId = localStorage.getItem('userId');
    axios.get(`${API_URL}Agent/${userId}`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      const agentData = res.data;
      this.setState({ agentData });
    })
    const agentId = parseInt(localStorage.getItem('userId'))
    const payload = {
      agentId: agentId
    };
   
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.typeId !== this.state.typeId) {
      this.fetchOptions(this.state.typeId);
    }
  }
  fetchOptions = (typeId) => {
    this.setState({ isLoading: true });
  
    const payload = {
      agentId: parseInt(localStorage.getItem('userId')), 
      typeId: parseInt(typeId, 10),
    };
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    axios
      .post(`${API_URL}AgentExt/allreferralsbytype`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const filteredOptions = res.data.map((item) => ({
          value: item.id,
          label: `${item.firstName} ${item.lastName} - ${this.getUserType(item.referralTypeId)}, ${item.email}`,
        }));
  
        this.setState({ optionGroup1: filteredOptions, isLoading: false });
      })
      .catch((error) => {
        console.error("Error fetching referrals:", error);
        this.setState({ isLoading: false });
      });
  };

toTitleCase(str) {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
  fetchEmailData = async () => {
    const { id } = this.props.match.params;
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const url = `${API_URL}Gmail/GetGmailByMessageId/${id}`;
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    }
    try {
      const response = await axios.get(url, config);
      this.setState({
        emailData: response.data,
        loading: false
      });
    } catch (error) {
      this.setState({
        error: error.message,
        loading: false
      });
    }
    const agentId = localStorage.getItem('userId');
    const url1 = `${API_URL}Gmail/GetTemplateDetails/${id}?agentId=${agentId}`;
    const config1 = {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    }
    try {
      this.setState({
       
        loading: true
      });
      const response1 = await axios.get(url1, config1);
      this.setState({
        //extractData: response1.data,
        listings: this.normalizeListings(response1.data),
        loading: false
      });
    } catch (error) {
    }
  }

  handleSubmit = (values, { setSubmitting }) => {
    const { listings } = this.state;
    
    const apiUrl = `${API_URL}ClientSellerShowing`;
     
      const payload = {
              clientId: parseInt(values.clientId),
              agentId: parseInt(localStorage.getItem("userId")) || 0,
              clientListingId: parseInt(values.engagementId),
              isActive: true,
              showingDate: listings[0].showingDate || null, 
              startTime: listings[0].startTime,
              endTime: listings[0].endTime,
              agentName: this.toTitleCase(listings[0].agentName) || "",
              agentOrganization: listings[0].organization || "",
              agentContact: listings[0].phone || "",
              agentEmail: listings[0].email || "",
              notes: listings[0].brokerage || "",
            };
        

    toast.loading("Submitting data...");

    axios
      .post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem("authUser"))?.resultData?.bearerToken}`,
        },
      })
      .then((response) => {
        toast.dismiss();
        if (response.data.success) {
          toast.success("Listing Assigned Successfully!");
        } else {
          toast.error(response.data.validationErrors?.[0] || "An error occurred.");
        }
        setSubmitting(false);
      })
      .catch((error) => {
        toast.dismiss();
        toast.error("Error: " + (error.response?.data?.message || error.message));
        setSubmitting(false);
      });
  };
normalizeListings(response) {
  if (!response) return [];

  // If response is already an array, normalize each item
  if (Array.isArray(response)) {
    return response.map(this.normalizeSingleListing);
  }

  // If response is an object, convert values to array
  const valuesArray = Object.values(response);

  // If the object contains multiple listings (each value is a listing object)
  const hasMultiple = valuesArray.every(
    (val) => val && typeof val === "object" && ("showing_date" in val || "dateText" in val)
  );

  if (hasMultiple) {
    return valuesArray.map(this.normalizeSingleListing);
  }

  // Otherwise, treat response itself as a single listing
  return [this.normalizeSingleListing(response)];
}

// Example normalizeSingleListing function
normalizeSingleListing(listing) {
  const rawDate = listing.showing_date || listing.dateText || "";
  const formattedDate = rawDate
    ? moment(rawDate.replace(/(\d+)(st|nd|rd|th)/, "$1"), "ddd, MMMM D").format("YYYY-MM-DD")
    : "";

  const agent = listing.agent || {};
  
  return {
    showingDate: formattedDate,
    startTime: listing.start_time || listing.startTime || "",
    endTime: listing.end_time || listing.endTime || "",
    agentName: listing.agent_name || agent.name || "",
    organization: listing.organization || agent.organization || "",
    email: listing.email || agent.email || "",
    phone: listing.phone || agent.phone || "",
    brokerage: listing.brokerage || "",
    address: listing.address || "",
  };
}


  render() {

    //meta title
    document.title = "Email | Realty Space";
    const { emailData, loading, error, extractData, listings, selectedMulti2, optionGroup1, isLoading } = this.state;
    // Debugging line
    return (
      <React.Fragment>
        <ToastContainer autoClose={2000}></ToastContainer>
        {loading ? (
          <div className="rs-loader-overlay">
            <div className="rs-loader"></div>
          </div>
        ) : null}
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Row className="project-header">
              <Col xl="7">
                <Breadcrumbs title="Email" breadcrumbItem="Assign To Client" />
              </Col>
              <Col xl="5">
                <div className="pt-2 float-end mt-2">

                  <div className="">


                  </div>

                </div>

              </Col>
            </Row>


            <Row className="mt-20">
              <Col xs="12">
                {/* Render Email SideBar */}
                <EmailSideBar agentData={this.state?.agentData?.agentId} />
                {/* <div className="email-leftbar card">
                 
                </div> */}
                <div className="email-rightbar mb-3" style={{marginLeft:0}}>
                  <Card>
                    {/* Render Email Top Tool Bar */}
                    <EmailToolbar />

                    <CardBody>
                      <div className="d-flex mb-4">

                        <img
                          className="d-flex me-3 rounded-circle avatar-sm"
                          src={avatar2}
                          alt="skote"
                        />
                        <div className="flex-grow-1">
                          <h5 className="font-size-14 mt-3">
                            {emailData?.from}
                          </h5>
                          {/* <small className="text-muted">
                            support@domain.com
                          </small> */}
                        </div>
                      </div>

                      <h4 className="mt-0 font-size-16">
                        {emailData?.subject}
                      </h4>
                        <SafeHTML html={emailData?.message} />
                    

                      {emailData?.createEmailAttachmentDetailCommands.map((attachmentDetail, key) =>
                        <div className="" key={key}>
                          {attachmentDetail.filePath}
                        </div>
                      )}

                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                              engagementId: '',
                              clientId:''
                        }}
                        validationSchema={Yup.object().shape({
                          engagementId: Yup.string().required("This Field in required"),
                         
                         
                        })}

                     onSubmit={this.handleSubmit}
                  
                     
                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >
                            <Card>
                              <CardBody>
                                <Row>
                               
                                  <Col sm="3">
                                  <ClientEngagementListSellerEmail />
                                  </Col>
                                  <Col sm="3">
                                      <div style={{marginTop:36}}></div>
                                      <UpdateButton btnClass="">Assign</UpdateButton>
                                 
                                  </Col>
                                 </Row>
                               
                              </CardBody>
                            </Card>
                          </Form>
                        )}
                      </Formik> 

                          <div className="table-rep-plugin">
                          <div
                            className="table-responsive mb-0"
                            data-pattern="priority-columns"
                          >
                            <Table
                              id="tech-companies-1"
                              className="table table-striped table-bordered"
                            >
                              <Thead>
                                <Tr>
                                  
                                  <Th>Showing Date / Time</Th>
                                  <Th>Agent Name</Th>
                                  <Th>Organization</Th>
                                  <Th>Email</Th>
                                  <Th>Phone</Th>
                                  <Th>Address</Th>
                                   <Th>Brokerage</Th>
                                </Tr>
                              </Thead>
                              {/* <Tbody>
                      {this.state.listings && (
                            <tr>
                                <td>
                                {this.state.listings.showing_date} / {this.state.listings.start_time} - {this.state.listings.end_time}
                                </td>
                                <td>{this.state.listings.agent_name}</td>
                                <td>{this.state.listings.organization}</td>
                                <td>{this.state.listings.email}</td>
                                <td>{this.state.listings.phone}</td>
                                <td>{this.state.listings.address}</td>
                                <td>{this.state.listings.brokerage}</td>
                            </tr>
                            )}
                              
                              </Tbody> */}

                              <Tbody>
  {this.state.listings &&
    // Convert object to array if necessary
    (Array.isArray(this.state.listings)
      ? this.state.listings
      : Object.values(this.state.listings)
    ).map((listing, index) => {
      // Normalize date
      const rawDate = listing.showing_date || listing.dateText || "";
      const formattedDate = rawDate
        ? moment(rawDate.replace(/(\d+)(st|nd|rd|th)/, "$1"), "ddd, MMMM D").format("YYYY-MM-DD")
        : "";

      // Normalize agent info
      const agent = listing.agent || {};
       // Debugging line
      const agentName = listing.agent_name || agent.name || "";
      const organization = listing.organization || agent.organization || "";
      const email = listing.email || agent.email || "";
      const phone = listing.phone || agent.phone || "";
      const brokerage = listing.brokerage || agent.brokeragePhone || "";

      // Time
      const startTime = listing.start_time || listing.startTime || "";
      const endTime = listing.end_time || listing.endTime || "";

      // Address
      const address = listing.address || "";

      return (
        <tr key={index}>
          <td>{moment(listing.showingDate).format('DD MMM')} / {listing.startTime} - {listing.endTime}</td>
          <td>{listing.agentName}</td>
          <td>{listing.organization}</td>
          <td>{listing.email}</td>
          <td>{listing.phone}</td>
          <td>{listing.address}</td>
          <td>{listing.brokerage}</td>
        </tr>
      );
    })}
</Tbody>

                            </Table>
                          </div>
                        </div>
                    </CardBody>
                  </Card>
                </div>
              </Col>
            </Row>
          </Container>

        </div>
      </React.Fragment>
    );
  }
}
EmailSeller.propTypes = {
  match: PropTypes.obj,

}
export default EmailSeller;
